module.exports = __webpack_public_path__ + "img/16.5389cb89.png";